// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Alert.less';

/**
 * `Alert` component.
 */
const Alert = ({ baseClassName, className, intent, children, onClose, ...props }) => (
    <div
        className={classNames(
            baseClassName,
            {
                [`${baseClassName}--${intent}`]: intent,
            },
            className,
        )}
        {...props}
    >
        {onClose && <span className="close" onClick={onClose} />}
        {children}
    </div>
);

Alert.propTypes = {
    /**
     * Visual intent color to apply to component.
     */
    intent: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
    /**
     * Content of the `Alert`
     */
    children: PropTypes.node,
    /**
     * Click handler for close button. Button will only be rendered if this prop is defined.
     */
    onClose: PropTypes.func,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Alert.defaultProps = {
    intent: null,
    children: null,
    onClose: null,
    className: null,
    baseClassName: `${CLS_PREFIX}alert`,
};

export default Alert;



// WEBPACK FOOTER //
// ./components/Alert/Alert.js